import React, { Component } from 'react';
import PropTypes from 'prop-types';

const breakSentence = /\b(\w|\w+[^\w\s]*\w+)\b/g;

class TextAreaMaxWords extends Component {
  constructor(props) {
    super(props);
    const { text } = props;

    this.state = {
      text,
    };

    this.handleChange = this.handleChange.bind(this);
    this.exceededMaxWords = this.exceededMaxWords.bind(this);
  }

  handleChange(event) {
    const text = event.target.value;
    const exceededLimit = this.exceededMaxWords(text);
    if (!exceededLimit) {
      this.setState({
        text,
      });
    }
  }

  exceededMaxWords(text) {
    const wordsCount = text.match(breakSentence) || [];
    const { maxWords } = this.props;

    return wordsCount.length > maxWords;
  }

  render() {
    const { text } = this.state;
    const {
      fieldName, fieldId, placeholder, required, className, label, maxWords,
    } = this.props;

    return (
      <div className="form-group mt-4">
        <label htmlFor={fieldId}>
          {label}
          {' '}
          (maximum
          {maxWords}
          {' '}
          words)
        </label>
        <textarea
          className={className}
          name={fieldName}
          id={fieldId}
          rows="4"
          placeholder={placeholder}
          onChange={this.handleChange}
          value={text}
          required={required}
        />
      </div>
    );
  }
}

TextAreaMaxWords.propTypes = {
  text: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  maxWords: PropTypes.number.isRequired,
};

TextAreaMaxWords.defaultProps = {
  text: '',
  placeholder: '',
  required: '',
  className: '',
};

export default TextAreaMaxWords;
